import React from 'react'
import { Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { CentralAmparoPageHeader } from '../../components/centralAmparo/CentralAmparoPageHeader'
import { modulesService } from '../../services/modules'
import {
  MODULE_NAME,
  DEFAULT_MODULE_TITLE,
  type ActiveTab,
} from '../../components/centralAmparo/parametrosHelpers'
import ParametrosUsuariosTab from './ParametrosUsuariosTab'
import ParametrosEspecialidadesTab from './ParametrosEspecialidadesTab'
import ParametrosAssistenciasTab from './ParametrosAssistenciasTab'
import ParametrosFormulariosTab from './ParametrosFormulariosTab'
import ParametrosIndisponibilidadeTab from './ParametrosIndisponibilidadeTab'
import ParametrosConfigTab from './ParametrosConfigTab'
import ParametrosMotivosTab from './ParametrosMotivosTab'
import { TriagemOpcoesPanel } from '../../components/centralAmparo/TriagemOpcoesPanel'

const SupportCenterParametros: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState<ActiveTab>('usuarios')
  const [moduleInfo, setModuleInfo] = React.useState<{
    display_name: string
    description: string | null
  } | null>(null)

  React.useEffect(() => {
    const loadModule = async () => {
      const result = await modulesService.getByName(MODULE_NAME)
      if (result.success && result.data) {
        setModuleInfo({
          display_name: result.data.display_name || DEFAULT_MODULE_TITLE,
          description: result.data.description || null,
        })
      }
    }
    void loadModule()
  }, [])

  const tabClass = (tab: ActiveTab) =>
    `py-3 px-1 border-b-2 font-medium text-sm ${
      activeTab === tab
        ? 'border-primary-600 text-primary-600 dark:text-primary-400'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200'
    }`

  return (
    <main className="flex-1 flex flex-col overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900">
        <PermissionGuard
          moduleName={MODULE_NAME}
          permissionType="show"
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <Text size="xl" className="text-gray-500 dark:text-gray-400 mb-2">
                  Acesso Negado
                </Text>
                <Text size="sm" color="muted">
                  Você não tem permissão para acessar esta página.
                </Text>
              </div>
            </div>
          }
        >
          <div className="h-full flex flex-col">
            <div className="px-6 pt-6">
              <div className="mb-6">
                <CentralAmparoPageHeader
                  title={moduleInfo?.display_name || DEFAULT_MODULE_TITLE}
                  description={moduleInfo?.description}
                />
              </div>

              <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="-mb-px flex space-x-8">
                  <button
                    type="button"
                    onClick={() => setActiveTab('usuarios')}
                    className={tabClass('usuarios')}
                  >
                    Profissionais
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('especializacoes')}
                    className={tabClass('especializacoes')}
                  >
                    Especialidades
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('assistencias')}
                    className={tabClass('assistencias')}
                  >
                    Assistências
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('indisponibilidade')}
                    className={tabClass('indisponibilidade')}
                  >
                    Indisponibilidade
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('motivos')}
                    className={tabClass('motivos')}
                  >
                    Motivos de cancelamento
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('opcoes')}
                    className={tabClass('opcoes')}
                  >
                    Triagem
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('parametros')}
                    className={tabClass('parametros')}
                  >
                    Parâmetros
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab('formularios')}
                    className={tabClass('formularios')}
                  >
                    Formulários
                  </button>
                </nav>
              </div>
            </div>

            {activeTab === 'usuarios' && <ParametrosUsuariosTab />}
            {activeTab === 'especializacoes' && <ParametrosEspecialidadesTab />}
            {activeTab === 'assistencias' && <ParametrosAssistenciasTab />}
            {activeTab === 'formularios' && <ParametrosFormulariosTab />}
            {activeTab === 'indisponibilidade' && <ParametrosIndisponibilidadeTab />}
            {activeTab === 'parametros' && <ParametrosConfigTab />}
            {activeTab === 'motivos' && <ParametrosMotivosTab />}
            {activeTab === 'opcoes' && (
              <div className="p-6">
                <TriagemOpcoesPanel />
              </div>
            )}
          </div>
        </PermissionGuard>
    </main>
  )
}

export default SupportCenterParametros
